import { render } from "./notice-pattern-create-import.vue?vue&type=template&id=2c0fd9f3"
import script from "./notice-pattern-create-import.vue?vue&type=script&lang=js"
export * from "./notice-pattern-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__